import { useEffect, useState } from "react";
import { http } from "@/api/client";
import { Trophy, Medal } from "lucide-react";

const MEDAL_COLORS = ["#ffcb47", "#c0c8d9", "#c67e4a"];

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { http.get("/leaderboard/legend").then(r => setRows(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="leaderboard-page">
      <div className="text-center bg-white rounded-3xl p-10 border border-black/5 shadow-sm">
        <div className="inline-flex w-16 h-16 rounded-2xl bg-[#FF8C42]/10 text-[#FF8C42] items-center justify-center">
          <Trophy className="w-8 h-8" />
        </div>
        <h1 className="mt-4 font-headings font-black text-3xl md:text-4xl text-[#1a2332]">Classement</h1>
        <p className="mt-2 text-[#5b6577] max-w-lg mx-auto text-sm">
          Classement basé sur le nombre de quiz « Niveau 2 » réussis. Ex-aequo : temps moyen de réponse.
        </p>
      </div>

      {rows.length === 0 ? (
        <div className="text-center text-[#5b6577] py-16 bg-white rounded-2xl border border-black/5" data-testid="leaderboard-empty">
          Aucun quiz « Niveau 2 » réussi pour l'instant. Soyez le premier !
        </div>
      ) : (
        <div className="space-y-2">
          {rows.map((r, i) => (
            <div key={r.user_id} data-testid={`leaderboard-row-${i}`}
              className="flex items-center gap-4 bg-white border border-black/5 shadow-sm rounded-2xl p-4">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center font-headings font-black text-xl"
                style={{ backgroundColor: i < 3 ? MEDAL_COLORS[i] : "#f3f5fa", color: i < 3 ? "#080C0E" : "#1a2332" }}>
                {i < 3 ? <Medal className="w-6 h-6" /> : i + 1}
              </div>
              <div className="flex-1">
                <div className="font-headings font-bold text-[#1a2332]">{r.user_name || "Élève"}</div>
              </div>
              <div className="text-right">
                <div className="font-headings font-black text-lg text-[#00a86b]">{r.legend_count}</div>
                <div className="text-xs text-[#5b6577]">quiz réussis</div>
              </div>
              <div className="text-right text-xs text-[#5b6577] min-w-[80px]">
                ⌀ {Math.round(r.avg_response_ms)}ms
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
